import React, { useEffect, useState } from "react";
import { useCurrentTheme } from "../hooks/app.hooks";
import { CssBaseline, PaletteMode, ThemeProvider } from "@mui/material";

export const THEME_TAG = "KICK_THEME";

export interface IAppThemeContextProps {

}

export interface IAppThemeContext extends IAppThemeContextProps {
	themeMode: PaletteMode;
	toggleThemeMode(): void;
}

export const AppThemeContext = React.createContext<IAppThemeContext>(
	{ ...{} as IAppThemeContext }
);

const AppThemeProvider: React.FC<IAppThemeContextProps> = (props) => {
	const [themeMode, setThemeMode] = useState<PaletteMode>(localStorage.getItem(THEME_TAG) as PaletteMode);
	const theme = useCurrentTheme(themeMode);

	async function toggleThemeMode() {
		const mode = themeMode === "light" ? "dark" : "light";
		setThemeMode(mode);
	}

	useEffect(() => {
		if (themeMode === "dark") {
			document.documentElement.style.setProperty("--svg-filter", "invert(1) hue-rotate(180deg)");
		} else {
			document.documentElement.style.setProperty("--svg-filter", "none");
		}
	}, [themeMode]);

	return (
		<AppThemeContext.Provider value={{
			...props,
			themeMode,
			toggleThemeMode
		}}>
			<ThemeProvider theme={theme}>
				<CssBaseline />
				{props.children}
			</ThemeProvider>
		</AppThemeContext.Provider>
	);
}

export default AppThemeProvider;